import Application from "./application/Application"
//import UIBaseApplicationFJ from "@/UI/application/UIBaseApplicationFJ";
import {IntegrationManager} from "@/Imports";
import * as PIXI from 'pixi.js';
import UIBaseApplication from "@baseUI/controllers/UIBaseApplication";

window.PIXI = PIXI
require("pixi-spine")

function loadThreePI_CDN() {
    const src = process.env.NODE_ENV !== 'production' ? "https://www.1x2-cloud-1.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js" :
    "https://www.1x2gamingcdn.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js" // live

    return new Promise((resolve, reject) => {
        const element = document.createElement('script')
        document.head.appendChild(element)

        element.src = src
        element.onload = () => {
            resolve()
        }
        element.onerror = (event) => {
            reject()
        }
    })
}

loadThreePI_CDN()
    .then(() => {
        new Application()
        new UIBaseApplication()
        new IntegrationManager()
    })
    .catch(() => {
        new Application()
        new UIBaseApplication()
    })

